<div class="d-flex flex-column">
  <pcs-tooltip *ngIf="labelSharedWithUser; else labelItem"
               [templateRef]="tooltipTrigger"
               [autoWidth]="true">
    <pcs-text-field [textFieldValue]="'dashboard.label.sharedBy' | translate | addColon"
                    class="me-1"></pcs-text-field>
    <pcs-text-field [textFieldValue]="creatorUser" textFieldStyle="Bold"></pcs-text-field>
  </pcs-tooltip>
</div>
<ng-template #tooltipTrigger let-tooltip>
  <div [ngbTooltip]="tooltip.tipContent"
       [tabIndex]="tooltip.tabIndex"
       container="body">
    <ng-template [ngTemplateOutlet]="labelItem"></ng-template>
  </div>
</ng-template>
<ng-template #labelItem>
  <div class="badge rounded-pill badge-sm"
       [title]="title"
       [ngClass]="labelItemClasses"
       [id]="id">
    <pcs-icon *ngIf="iconLeft"
              icon="{{iconLeft}}"
              class="icon-left"></pcs-icon>
    <span class="badge-text">
      {{name | translate}}
  </span>
    <pcs-icon *ngIf="iconRight"
              icon="{{iconRight}}"
              class="icon-right">
    </pcs-icon>
  </div>
</ng-template>
